import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import TopHeadingDividerComponent from "../AccountSetting/TopHeadingDividerComponent";
import IOSSwitch from "../NotificationsSetting/IOSSwitch";
import SaveChangingsButton from "../AccountSetting/SaveChangingsButton";
const messagingPrivacySettingdata = [
  "Enable message request notifications",
  "Invitations from your network",
  "Allow connections to add you on group",
  "Reply to comments",
  "Messages from activity on my page or channel",
  "Personalise tips for my page",
];
const messagingExperienceData = [
  "Read Receipts and typing indicators",
  "Message suggestions",
  "Message nudges",
];
function MessagingSettingSection() {
  return (
    <Stack
      sx={{
        bgcolor: "#ffffff",
        p: "20px",
        borderRadius: "20px",
        pb: "100px",
      }}
    >
      <TopHeadingDividerComponent
        primary="Messaging privacy settings"
        secondary="As young ye hopes no he place means. Partiality diminution gay yet entreaties admiration. In mention perhaps attempt pointed suppose. Unknown ye chamber of warrant of Norland arrived."
      />
      <Box
        sx={{
          pt: "12px",
          display: "flex",
          flexDirection: "column",
          pb: "10px",
        }}
      >
        {messagingPrivacySettingdata.map((data) => (
          <>
            {" "}
            <Stack
              direction="row"
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "21.78px",
                  }}
                >
                  {data}
                </Typography>
              </Box>{" "}
              <IOSSwitch />
            </Stack>
            <Divider
              sx={{
                height: "1px",
                bgcolor: "#EBEBEB",
                border: "none",
                mx: "-20px",
                my: "6px",
              }}
            />
          </>
        ))}
        <SaveChangingsButton alignSelf="end">
          Save Changings
        </SaveChangingsButton>
      </Box>
      <TopHeadingDividerComponent
        primary="Messaging experience"
        secondary="Arrived off she elderly beloved him affixed noisier yet."
      />
      <Box sx={{ pt: "12px", display: "flex", flexDirection: "column" }}>
        {messagingExperienceData.map((data) => (
          <>
            {" "}
            <Stack
              direction="row"
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "21.78px",
                  }}
                >
                  {data}
                </Typography>
              </Box>{" "}
              <Button
                variant="contained"
                startIcon={
                  <Box
                    component="img"
                    src="/icons/writeIcon.svg"
                    sx={{ width: "18px", height: "18.11px" }}
                  ></Box>
                }
                sx={{
                  width: "120px",
                  py: "4px",
                  alignSelf: "start",
                  borderRadius: "20.5px",
                  px: "22px",
                  // minWidth: "auto",
                  // width: "auto",
                  textTransform: "none",
                  bgcolor: "transparent",
                  color: "#000000",
                  boxShadow: "none",
                  border: "1px solid #000000",
                  "&:hover": {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  },
                  "&:active": {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  },
                  "&:focus": {
                    outline: "none",
                    boxshadow: "none",
                  },
                  "& .MuiButtonBase-root": {
                    width: "auto !important",
                    minWidth: "0px !important",
                    padding: "0px",
                    boxshadow: "none",
                  },
                }}
              >
                Change
              </Button>
            </Stack>
            <Divider
              sx={{
                height: "1px",
                bgcolor: "#EBEBEB",
                border: "none",
                mx: "-20px",
                my: "6px",
              }}
            />
          </>
        ))}
        <SaveChangingsButton alignSelf="end">
          Save Changings
        </SaveChangingsButton>
      </Box>
    </Stack>
  );
}

export default MessagingSettingSection;
